export default "__VITE_ASSET__f1c386aa__"